import { api } from "@/lib/api"
import type { Tenant } from "@rentbase/shared"

export const tenantsService = {
  async list(): Promise<Tenant[]> {
    const { data } = await api.get("/api/tenants")
    return data.data
  },
  async get(id: string): Promise<Tenant> {
    const { data } = await api.get(`/api/tenants/${id}`)
    return data.data
  },
  async create(input: Record<string, unknown>): Promise<Tenant> {
    const { data } = await api.post("/api/tenants", input)
    return data.data
  },
  async update(id: string, input: Record<string, unknown>): Promise<Tenant> {
    const { data } = await api.put(`/api/tenants/${id}`, input)
    return data.data
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/api/tenants/${id}`)
  },

  async uploadPhoto(id: string, file: File): Promise<{ photo_url: string }> {
    const form = new FormData()
    form.append("photo", file)
    const { data } = await api.post(`/api/tenants/${id}/photo`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data.data
  },

  async deletePhoto(id: string): Promise<void> {
    await api.delete(`/api/tenants/${id}/photo`)
  },

  async listDocuments(tenantId: string) {
    const { data } = await api.get("/api/documents", {
      params: { entity_type: "tenant", entity_id: tenantId },
    })
    return data.data as Array<{
      id: string
      file_name: string
      file_url: string
      file_size_kb: number
      category: string | null
      expiry_date: string | null
      notes: string | null
      uploaded_at: string
    }>
  },

  async uploadDocument(
    tenantId: string,
    file: File,
    category?: string,
    notes?: string
  ) {
    const form = new FormData()
    form.append("file", file)
    form.append("entity_type", "tenant")
    form.append("entity_id", tenantId)
    if (category) form.append("category", category)
    if (notes) form.append("notes", notes)
    const { data } = await api.post("/api/documents/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data.data
  },

  async deleteDocument(documentId: string): Promise<void> {
    await api.delete(`/api/documents/${documentId}`)
  },
}
